// Centralized data-testid map
export const TID = {
  // global
  header: "site-header",
  headerLogo: "header-logo",
  headerCta: "header-cta",
  langToggle: "lang-toggle",
  langRo: "lang-ro",
  langEn: "lang-en",
  langTr: "lang-tr",
  mobileMenuBtn: "mobile-menu-btn",
  mobileMenu: "mobile-menu",
  footer: "site-footer",
  footerEmail: "footer-email",
  footerPhone: "footer-phone",
  // nav links
  navHome: "nav-home",
  navAbout: "nav-about",
  navSolutions: "nav-solutions",
  navExpertise: "nav-expertise",
  navApplications: "nav-applications",
  navContact: "nav-contact",
  // home sections
  hero: "hero",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  about: "section-about",
  process: "section-process",
  solutions: "section-solutions",
  expertise: "section-expertise",
  sourcing: "section-sourcing",
  applications: "section-applications",
  why: "section-why",
  experience: "section-experience",
  experienceShort: "section-experience-short",
  finalCta: "section-final-cta",
  ctaEmail: "cta-email",
  ctaPhone: "cta-phone",
  // pages
  pageAbout: "page-about",
  pageSolutions: "page-solutions",
  pageExpertise: "page-expertise",
  pageContact: "page-contact",
  contactEmail: "contact-email",
  contactPhone: "contact-phone",
};
